import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from "@/config";
import './plugins/element.js'
import utils from '@/lib/utils'
import G2 from '@antv/g2'

import onlyNumber from '@/directive/el-input'; //添加此行=>自定义全局指令

// import './assets/iconfont.css';
import './assets/iconfont.js';
// import './plugins/directives.js';
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.config.productionTip = false
    // const EncodingPlugin = require('webpack-encoding-plugin');
    // module.exports = {
    //     plugins: [new EncodingPlugin({
    //         encoding: 'iso-8859-1'
    //     })]
    // };

// import marquee from 'marquee-components'
// Vue.use(marquee );

// import scroll from 'vue-seamless-scroll'
// Vue.use(scroll)
// 拦截请求
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem("token");
        if (token) {
            //  console.log(token)
            config.headers.token = token;
        }
        // router.replace({path: '/login'})
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

// 拦截响应
axios.interceptors.response.use(
    response => {
        // console.log('拦截响应',response)
        if (response.data.resultCode == -2) {
            // console.log(response.data.resultCode)
            router.replace({ path: '/backLogin' })
        } else {
            return response
        }

    },
    err => {
        console.log(err);
        if (err.response) {
            switch (err.response.status) {
                case 401:
                    // 这里写清除token的代码
                    // router.replace({
                    //   path: 'login',
                    //   query: {redirect: router.currentRoute.fullPath} // 登录成功后跳入浏览的当前页面
                    // })
            }
        }
        return Promise.reject(err)
    }
)

Vue.use(VueAxios, axios, G2);

Vue.use(onlyNumber); //添加此行=>使用该全局指令

router.beforeEach((to, from, next) => {
    if (!store.state.config.login.copy) {
        let url = "config.json";
        let param = {}
        axios.get(url, param).then(res => {
            let data = res.data;
            store.state.config = data.data;
        })
    }
    let tokenUrl = decodeURIComponent((new RegExp('[?|&]' + 'token' + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    if (tokenUrl) {
        let token = decodeURIComponent((new RegExp('[?|&]' + 'token' + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
        let referrer = decodeURIComponent((new RegExp('[?|&]' + 'url' + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
        // store.state.fromSys = fromSys;
        // sessionStorage.setItem("fromSys", fromSys);
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("referrer", referrer /*document.referrer*/ );

        let url = config.url + "SysUserController/getCurrentLoginUser.action";
        let param = {}
        axios.post(url, param).then(res => {
            let data = res.data;
            if (data.resultCode == 200) {
                store.state.token = data.data.username;
                store.state.sysRole = data.data.sysRole;
                sessionStorage.setItem("userName", data.data.userName);
                sessionStorage.setItem("sysRole", data.data.sysRole);
                setCookie("weackCurrentChangeGroup", '');
                setCookie("languageType", '1');

                function setCookie(name, value) { //存入cookie
                    var time = 24 * 300 * 60 * 60 * 1000;
                    var exp = new Date();
                    var expires = new Date(exp.getTime() + time);
                    document.cookie = name + '=' + escape(value) + ';expires=' + expires.toGMTString() + ';path=/';
                }
                // next();
                next({
                    path: '/back/dashboard',
                    query: {}
                })
            }
        })
        next();
    } else {
        next();
    }

    //   let userName = sessionStorage.getItem("userName");
    //   if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    //     if (store.state.token || userName) {  // 通过vuex state获取当前的token是否存在
    //       next();
    //     }
    //     else {
    //       next({
    //         path: '/login',
    //         query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //       })
    //     }
    //   }
    //   else {
    //     next();
    //   }
})

router.afterEach((transition) => {
    // utils.setTitle(transition.meta.title)
})

Vue.filter('NumFormat', function(value) {
    if (!value) return ''
    value = value.toFixed(0)
    var intPart = Number(value).toFixed(0) // 获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    var floatPart = '' // 预定义小数部分
    var value2Array = value.split('.')
        // =2表示数据有小数位
    if (value2Array.length === 2) {
        floatPart = value2Array[1].toString() // 拿到小数部分
        if (floatPart.length === 1) { // 补0,实际上用不着
            return intPartFormat + '.' + floatPart + '0'
        } else {
            return intPartFormat + '.' + floatPart
        }
    } else {
        return intPartFormat + floatPart
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')